export default __webpack_public_path__ + "static/media/google-icon.48520c7a.svg";